import { createApi } from "@reduxjs/toolkit/query/react";
import { testingUrl } from "../../views/Apis";
import { axiosBaseQuery } from "../axiosBaseQuery";

export const divisionManagerAPI = createApi({
    reducerPath: "divisionManagerAPI",
    baseQuery: axiosBaseQuery({ baseUrl: testingUrl }),
    endpoints: () => ({}),
});
